import { initializeApp, type FirebaseApp } from 'firebase/app';
import { getAuth, type Auth } from 'firebase/auth';
import { getFirestore, type Firestore } from 'firebase/firestore';

// Firebase web config — public by design (zabezpieczenia w Firestore Rules, nie w kluczach).
// https://firebase.google.com/docs/projects/api-keys
//
// authDomain UWAGA: domyślnie ustawiamy host bieżącej apki (rodzinkafinance.pl
// na prod, localhost w dev). Powód: mobile browsery (Safari ITP, Brave Shields,
// Firefox 3rd-party cookies blocking) blokują iframe + storage cross-origin
// do firebaseapp.com → signInWithRedirect tracił sesję, user wracał na /login
// bez auth state. Same-origin auth handler (Firebase Hosting auto-serwuje
// /__/auth/handler na tym samym hostingu) eliminuje 3rd-party cookie issue.
//
// FALLBACK: gdy hostname to firebaseapp.com (preview channels) lub nieznany —
// używamy domyślnego firebaseapp.com który zawsze działa.
// authDomain ROLLBACK na firebaseapp.com — legacy działał z tym 2+ lata.
// Same-origin (rodzinkafinance.pl) wymaga że:
//   1. /__/auth/handler nie jest złapane przez nasz "**" rewrite w firebase.json
//   2. rodzinkafinance.pl jest w Firebase Auth Authorized Domains (manualnie w Console)
// Bez 1. lub 2. desktop popup nie otwiera się ("nic się nie dzieje"). Wracamy
// do firebaseapp.com — stabilne, działa na desktop. Mobile redirect mogą
// mieć 3rd-party cookie issue (Safari ITP) — to osobny problem do rozwiązania
// po desktop-fix.
const FIREBASE_CONFIG = {
  apiKey: 'AIzaSyC-uEmrE7wHx2iQ0YLhoEASeDnHEbYu6xQ',
  authDomain: 'rodzinka-finance-claude.firebaseapp.com',
  projectId: 'rodzinka-finance-claude',
  storageBucket: 'rodzinka-finance-claude.firebasestorage.app',
  messagingSenderId: '129065045127',
  appId: '1:129065045127:web:63c54c52a08723113b7c22',
  measurementId: 'G-1RK7CM74W9',
};

export const IS_DEV_MODE = new URLSearchParams(window.location.search).has('dev');

const DB_PREFIX = IS_DEV_MODE ? 'dev_' : '';

export const COLLECTIONS = {
  families: `${DB_PREFIX}families`,
  wallets: `${DB_PREFIX}wallets`,
  transactions: `${DB_PREFIX}transactions`,
  categories: `${DB_PREFIX}categories`,
  budgets: `${DB_PREFIX}budgets`,
  goals: `${DB_PREFIX}goals`,
  userStats: `${DB_PREFIX}userStats`,
} as const;

export const app: FirebaseApp = initializeApp(FIREBASE_CONFIG);
export const auth: Auth = getAuth(app);
export const db: Firestore = getFirestore(app);

if (import.meta.env.DEV) {
  console.info('[firebase] init OK', { project: FIREBASE_CONFIG.projectId, devMode: IS_DEV_MODE });
}
